(function () {
  if (customElements.get("confetti-overlay")) return;

  var PALETTES = {
    primary: ["#ED1A3D", "#FFEB3D", "#009688", "#0693e3"],
    champagne: ["#f5d49a", "#e8b96b", "#ffffff", "#d4a259"],
    sakura: ["#ffd1dc", "#ffa8c5", "#ffffff", "#d4a5b9"],
    mint: ["#b8e6d3", "#7dd3a8", "#ffffff", "#4ea882"],
    midnight: ["#c5b4e3", "#8b7ab8", "#f4e8a3", "#ffffff"],
  };

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function pick(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  customElements.define(
    "confetti-overlay",
    class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        if (!this._isInDateRange()) return;

        this._canvas = document.createElement("canvas");
        this._ctx = this._canvas.getContext("2d");
        if (!this._ctx) return;

        this._particles = [];
        this._raf = null;
        this._frame = 0;
        this._paused = false;

        this._maxParticles = Math.min(parseInt(this.getAttribute("particle-count"), 10) || 180, 600);
        this._speed = Math.min(Math.max(parseFloat(this.getAttribute("fall-speed")) || 1, 0.5), 2);
        this._opacity = Math.min(Math.max(parseFloat(this.getAttribute("opacity")) || 0.85, 0.3), 1);
        this._colors = PALETTES[this.getAttribute("color-palette")] || PALETTES.primary;

        this.appendChild(this._canvas);
        this._resize = this._resize.bind(this);
        this._tick = this._tick.bind(this);
        this._handleVisibility = this._handleVisibility.bind(this);

        this._resize();
        window.addEventListener("resize", this._resize);
        document.addEventListener("visibilitychange", this._handleVisibility);
        this._raf = window.requestAnimationFrame(this._tick);
      }

      disconnectedCallback() {
        window.cancelAnimationFrame(this._raf);
        window.removeEventListener("resize", this._resize);
        document.removeEventListener("visibilitychange", this._handleVisibility);
      }

      _isInDateRange() {
        var now = new Date();
        var start = this.getAttribute("start-date");
        var end = this.getAttribute("end-date");

        if (start && now < new Date(start + "T00:00:00")) return false;
        if (end && now > new Date(end + "T23:59:59")) return false;
        return true;
      }

      _resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        this._width = window.innerWidth;
        this._height = window.innerHeight;
        this._dpr = dpr;

        this._canvas.width = Math.floor(this._width * dpr);
        this._canvas.height = Math.floor(this._height * dpr);
        this._canvas.style.width = this._width + "px";
        this._canvas.style.height = this._height + "px";
        this._ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }

      _handleVisibility() {
        this._paused = document.hidden;
        if (!this._paused) {
          this._raf = window.requestAnimationFrame(this._tick);
        }
      }

      _tick() {
        if (this._paused) return;

        this._ctx.clearRect(0, 0, this._width, this._height);

        if (this._frame % 2 === 0 && this._particles.length < this._maxParticles) {
          for (var i = 0; i < this._colors.length; i++) {
            this._particles.push(this._createParticle(this._colors[i]));
          }
        }

        for (var j = this._particles.length - 1; j >= 0; j--) {
          var particle = this._particles[j];
          this._updateParticle(particle);
          this._drawParticle(particle);

          if (particle.life >= particle.maxLife || particle.y > this._height + 24) {
            this._particles.splice(j, 1);
          }
        }

        this._frame++;
        this._raf = window.requestAnimationFrame(this._tick);
      }

      _createParticle(color) {
        return {
          x: random(-this._width, this._width),
          y: -this._height / 2,
          vx: random(1, 3) * this._speed,
          vy: random(2, 4) * this._speed,
          color: color,
          life: 0,
          maxLife: 360,
          degree: random(0, 360),
          size: Math.floor(random(8, 10)),
        };
      }

      _updateParticle(particle) {
        particle.degree += 1;
        particle.vx *= 0.99;
        particle.vy *= 0.999;
        particle.x += particle.vx + Math.cos((particle.degree * Math.PI) / 600);
        particle.y += particle.vy;
        particle.life++;
      }

      _drawParticle(particle) {
        var width = particle.size;
        var height = Math.cos((particle.degree * Math.PI) / 40) * particle.size;
        var ctx = this._ctx;

        ctx.save();
        ctx.globalAlpha = this._opacity;
        ctx.fillStyle = particle.color;
        ctx.beginPath();
        ctx.moveTo(particle.x, particle.y);
        ctx.lineTo(particle.x + width / 2, particle.y + height);
        ctx.lineTo(particle.x + width + width / 2, particle.y + height);
        ctx.lineTo(particle.x + width, particle.y);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }
    },
  );
})();
